import type { Theme } from '@mui/material/styles';

const Table = (theme: Theme) => {
  return {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: theme.palette.background.neutral,
          color: theme.palette.text.secondary,
        },
        paddingCheckbox: {
          paddingLeft: theme.spacing(1),
        },
        root: {
          borderBottom: 'none',
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTablePagination: {
      defaultProps: {
        backIconButtonProps: {
          size: 'small',
        },
        nextIconButtonProps: {
          size: 'small',
        },
        SelectProps: {
          MenuProps: {
            MenuListProps: {
              sx: {
                '& .MuiMenuItem-root': {
                  ...theme.typography.body2,
                },
              },
            },
          },
        },
      },

      styleOverrides: {
        actions: {
          marginRight: theme.spacing(1),
        },
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        toolbar: {
          height: 64,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
            backgroundColor: theme.palette.action.selected,
          },
        },
      },
    },
  };
};

export default Table;
